import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { Minus, Plus, Trash2, ShoppingBag, ArrowRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import { absoluteShopUrl } from "./api";

export default function CartDrawer({ open, onClose }) {
  const cart = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent
        side="right"
        data-testid="cart-drawer"
        className="bg-[var(--gx-surface)] border-l border-line text-white flex flex-col w-full sm:max-w-md"
      >
        <SheetHeader>
          <SheetTitle className="text-white font-display flex items-center gap-2">
            <ShoppingBag className="w-4 h-4 text-gold" /> Your Cart
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto no-scrollbar mt-4 space-y-4">
          {cart.items.length === 0 ? (
            <p className="text-dim text-sm py-10 text-center" data-testid="cart-empty-message">
              Your cart is empty.
            </p>
          ) : (
            cart.items.map((item) => (
              <div key={item.product_id} className="flex gap-3" data-testid={`cart-item-${item.product_id}`}>
                <div className="w-16 h-16 rounded-lg overflow-hidden bg-[var(--gx-surface-2)] shrink-0">
                  {item.image ? (
                    <img src={absoluteShopUrl(item.image)} alt="" className="w-full h-full object-cover" />
                  ) : null}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{item.name}</p>
                  <p className="text-gold text-sm mt-0.5">₹{Number(item.price).toLocaleString("en-IN")}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <button
                      onClick={() => cart.updateQty(item.product_id, item.qty - 1)}
                      data-testid={`cart-decrease-${item.product_id}`}
                      className="w-6 h-6 rounded-full border border-line flex items-center justify-center text-dim hover:text-gold"
                    >
                      <Minus className="w-3 h-3" />
                    </button>
                    <span className="text-xs w-5 text-center">{item.qty}</span>
                    <button
                      onClick={() => cart.updateQty(item.product_id, item.qty + 1)}
                      data-testid={`cart-increase-${item.product_id}`}
                      className="w-6 h-6 rounded-full border border-line flex items-center justify-center text-dim hover:text-gold"
                    >
                      <Plus className="w-3 h-3" />
                    </button>
                    <button
                      onClick={() => cart.removeItem(item.product_id)}
                      data-testid={`cart-remove-${item.product_id}`}
                      className="ml-2 text-mute hover:text-red-400"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.items.length > 0 && (
          <div className="border-t border-line pt-4 mt-4">
            <div className="flex items-center justify-between text-sm mb-4">
              <span className="text-dim">Subtotal</span>
              <span className="text-gold font-display text-lg" data-testid="cart-subtotal">
                ₹{cart.subtotal.toLocaleString("en-IN")}
              </span>
            </div>
            <button
              type="button"
              onClick={() => {
                onClose();
                navigate("/checkout");
              }}
              data-testid="cart-checkout-button"
              className="btn-gold w-full"
            >
              Checkout <ArrowRight className="w-3.5 h-3.5" />
            </button>
            <Link to="/shop" onClick={onClose} className="block text-center text-[12px] text-mute hover:text-gold mt-3">
              Continue shopping
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
